<nav class="navbar navbar-expand-lg bg-dark rounded" *ngIf="loggedIn">
    <!--
    <a class="navbar-brand title" routerLink="home" routerLinkActive="active">
        <img class="ms-3" src="../../assets/img/motoria/logo-motoria-p.png" />
    </a>
    -->
    <a class="navbar-brand title" routerLink="home" routerLinkActive="active">
        <img class="ms-3" src="../../assets/img/brainscorm/bs.png" />
    </a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample"
        aria-controls="navbarsExample" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div id="user-name" *ngIf="userName != ''">
        <span class="fw-bold">Bienvenido, {{ userName }}</span>
    </div>

    <div class="collapse navbar-collapse" id="navbarsExample">
        <ul class="navbar-nav ms-auto">
            <li class="nav-item">
                <a class="nav-link" routerLink="my-categories-courses" routerLinkActive="active">
                    <i class="fas fa-graduation-cap"></i>
                    <span>Mis cursos</span>
                </a>
            </li>
            <!--
            <li class="nav-item">
                <a class="nav-link" routerLink="repository" routerLinkActive="active">
                    <i class="fas fa-warehouse"></i>
                    <span>Repositorio</span>
                </a>
            </li>
            -->
            <!--
            <li class="nav-item">
                <a class="nav-link" routerLink="help" routerLinkActive="active">
                    <i class="fas fa-question-circle"></i>
                    <span>Ayuda</span>
                </a>
            </li>
            -->
            <!--
            <li class="nav-item">
                <a class="nav-link" routerLink="contact" routerLinkActive="active">
                    <i class="far fa-envelope"></i>
                    <span>Contacto</span>
                </a>
            </li>
            -->
            <li class="nav-item" *ngIf="admin">
                <a class="nav-link" routerLink="users" routerLinkActive="active">
                    <i class="fas fa-users"></i>
                    <span>Usuarios</span>
                </a>
            </li>
            <li class="nav-item" *ngIf="admin">
                <a class="nav-link" routerLink="logs" routerLinkActive="active">
                    <i class="fas fa-book"></i>
                    <span>Registros</span>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="logout()">
                    <i class="fas fa-sign-out-alt"></i>
                    <span>Cerrar sesión</span>
                </a>
            </li>
        </ul>
    </div>
</nav>
<router-outlet></router-outlet>